import copy from 'copy-to-clipboard';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { DataNotFound } from '../../../components/DataNotFound';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import { updatedCart } from '../../../features/updatedCartSlice';
import { addToCart } from '../../../features/usercartSlice';
import { PageHitCountApi } from '../../../shared/Helper';
// import BannerImg from '../../../../public/assets/images/BannersFiles/31.jpg';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import LoadingAnimation from '../../../components/LoadingAnimation';
import LoaderModal from '../../../components/common/LoaderModal';
import ModalCartSuccessful from '../../../components/elements/ModalCartSuccessfull';
import ProjectsCard from '../../../components/elements/ProjectsCard';
import SMSModal from '../../../components/elements/SMSModal';
import StaticBanner from '../../../components/elements/StaticBanner';
import CampaignsCard from '../../../components/elements/CampaignsCard';

const PermanentCampaigns = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const Mainmenu = useSelector((state) => state.campaignMenu.permanentmenu);
  const [value, setValue] = useState([]);
  const [dataValue, setDataValue] = useState([]);
  const [modalMessageText, setModalMessageText] = useState('');
  const [modalExist, setModalExist] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [isCart, setIsCart] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [epUserID, setEpUserID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethodId, setPaymentMethodId] = useState(1);
  const [projectGuID, setprojectGuID] = useState('');
  const [errorStates, setErrorStates] = useState([]);
  const [amount, setAmount] = useState(0);
  const [count, setCount] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(currentIndex);
  const [smsModal, setSmsModal] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [projectId, setProjectId] = useState('');

  const token = localStorage.getItem('token');
  const { id } = useParams();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const parts = pathname.split('/');
  parts.pop();
  const newPath = parts.join('/') + '/';

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, [id]);

  useEffect(() => {
    localStorage.setItem('isHome', newPath != `/user/PermanentCampaigns/` ? true : false);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setValue(null);
      setLoading(true);
      try {
        await getAsync(`APIClient/CampaignProjectSHJC?ModuleId=${id}`).then((response) => {
          const result = response;
          setValue(result);
          setLoading(false);
        });
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
  }, [epUserID]);

  useEffect(() => {
    if (value?.data && value?.data?.length > 0) {
      setSelectedValues(Array(value?.data?.length).fill(1)); // Default to One Time selected
    }
  }, [value?.data]);

  const dataObject = {
    paymentMethodId,
    amount,
  };
  
  const updateErrorState = (index, isError) => {
    setErrorStates((prevStates) => {
      const newErrorStates = [...prevStates];
      newErrorStates[index] = isError;
      return newErrorStates;
    });
  };

  // Function to handle donation
  const DonateHandle = (currentIndex, i, id, price, referralLink, isContribution, projectTypeIdInt) => {
    // let selectedAmount = currentIndex !== i ? price : amount;
let selectedAmount = currentIndex == i ? Number(amount) : 0;
    if (selectedAmount > 0) {
      if (selectedAmount == 0) {
        updateErrorState(isContribution, true);
        return;
      } else {
        updateErrorState(isContribution, false);
        const payload = {
          ...dataObject,
          amount: selectedAmount,
          isContribution,
        };
        const link = `/externalPayment/${id}/${referralLink}/12/${projectTypeIdInt}`;
        navigate(link, { state: { paymentInfo: payload } });
      }
    } else {
      toast.error(`${t('Amount must be greater than 0')}`);
    }
  };

  if (loading) return <LoadingAnimation styling={' h-screen'} />;

  const addCartItem = async (currentIndex, i, price, pId, projectTypeIdInt) => {
    try {
      // let selectedAmount = currentIndex !== i ? price : amount;
      let selectedAmount = currentIndex == i ? Number(amount) : 0;
      if (selectedAmount > 0) {
        if (selectedAmount !== 0) {
          setIsLoading(true);
          const res = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
          setDataValue(res?.data);
          dispatch(addToCart(res?.data));
          const response = await postAsync(`APIClient/ProjectListGUID`, [
            { ProjectId: pId, ProjectTypeIdInt: projectTypeIdInt },
          ]);
          // if (response.statusCode) {
          //   setModalMessageText('Item not added in cart');
          //   setModalExist(true);
          //   setGridModalOpen(true);
          // }
          if (response) {
            setIsLoading(false);
          }
          const newItem = response?.data;
          const cartbody = {
            cartID: 0,
            projectName: newItem[0]?.titleAr || newItem[0]?.titleEn,
            epUserID: epUserID,
            ip: 'string',
            projectID: newItem[0]?.id,
            amount: selectedAmount,
            projectTypeIdInt
          }; 
          if (token && res?.statusCode === 204) {
            await postAsync(`Cart/CreateCart`, cartbody);
            const resp = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
            dispatch(addToCart(resp?.data));
            dispatch(updatedCart(true));
            setModalMessageText('Add to cart Successfully');
            setModalExist(false);
            setGridModalOpen(true);
            return;
          } else if (res.data?.length && res?.statusCode === 200) {
            const itemExistsdatabase = res?.data?.some((item) => item.projectID === pId);

            if (token && !itemExistsdatabase) {
              await postAsync(`Cart/CreateCart`, cartbody);
              const respo = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, {
                EPUserID: epUserID,
              });
              dispatch(addToCart(respo?.data));
              dispatch(updatedCart(true));
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            } else {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
            }
          }

          if (!token) {
            const updateCart = (data) => {
              const updatedData = data.map((item) => {
                if (item?.id === newItem[0].id) {
                  return { ...item, price: selectedAmount };
                }
                return item;
              });
              localStorage.setItem('cart', JSON.stringify(updatedData));
            };

            // Retrieve existing cart data or create an empty array
            const existingData = JSON.parse(localStorage.getItem('cart')) || [];
            // Check if item exists and update price if needed
            const itemExists = existingData.some((item) => item?.id === newItem[0]?.id);
            if (itemExists) {
              setIsCart(true);
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
              updateCart(existingData);
            } else {
              setIsCart(true);
              // toast.success('Add to cart Successfully');
              dispatch(updatedCart(true));
              newItem[0].price = selectedAmount;
              updateCart([...existingData, ...newItem]);
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            }
          }
        } else {
          setprojectGuID(pId);
        }
      } else {
        toast.error(`${t('Amount must be greater than 0')}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareLink = (guid, projectTypeIdInt) => {
    setIsLoading(true);
    const shareLink = `${reactURL}/PaymentProcess/` + guid + '/' + guid + '/' + 12 + '/' + projectTypeIdInt;
    copy(shareLink);
    toast.success(t('Link copy Successfully'));
    setIsLoading(false);
  };
  const handleOnChange = (index, value) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = value; // Update only the current card's selection
    setSelectedValues(newSelectedValues);
    setPaymentMethodId(value);
  };

  return (
    <>
      {true ? (
        <div className="">
          {Mainmenu?.map((data) => {
            if (data?.moduleID == +id) {
              return (
                <StaticBanner
                  BannerImg={BannerImg}
                  // picture={data?.picture}
                  picture={BannerImg}
                  ar_SA={data?.title_AR}
                  en_US={data?.title_EN}
                  arabic={true}
                />
              );
            }
          })}

          <div className="container-fluid py-5 justify-center">
            <div className="row px-4 sm:px-5 md:px-5 lg:px-5  justify-center">
              {/*news box 1 */}
              {value?.data?.length > 0 ? (
                value?.data?.map((data, i) => {
                  return (
                    // <ProjectsCard
                    //   key={i}
                    //   i={i}
                    //   data={data}
                    //   handleOnChange={handleOnChange}
                    //   handleShareLink={handleShareLink}
                    //   addCartItem={addCartItem}
                    //   DonateHandle={DonateHandle}
                    //   previousIndex={previousIndex}
                    //   setPreviousIndex={setPreviousIndex}
                    //   setCurrentIndex={setCurrentIndex}
                    //   setCount={setCount}
                    //   setAmount={setAmount}
                    //   amount={amount}
                    //   count={count}
                    //   currentIndex={currentIndex}
                    //   errorStates={errorStates}
                    //   isLoading={isLoading}
                    //   selectedValues={selectedValues}
                    //   setSmsModal={setSmsModal}
                    //   setProjectId={setProjectId}
                    // />
                    <CampaignsCard
                      key={i}
                      i={i}
                      data={data}
                      handleOnChange={handleOnChange}
                      handleShareLink={handleShareLink}
                      addCartItem={addCartItem}
                      DonateHandle={DonateHandle}
                      previousIndex={previousIndex}
                      setPreviousIndex={setPreviousIndex}
                      setCurrentIndex={setCurrentIndex}
                      setCount={setCount}
                      setAmount={setAmount}
                      amount={amount}
                      count={count}
                      currentIndex={currentIndex}
                      errorStates={errorStates}
                      isLoading={isLoading}
                      selectedValues={selectedValues}
                      setSmsModal={setSmsModal}
                      setProjectId={setProjectId}
                    />
                  );
                })
              ) : (
                <>
                  <DataNotFound />
                </>
              )}
              {
                <ModalCartSuccessful
                  modalMessageText={modalMessageText}
                  modalExist={modalExist}
                  setGridModalOpen={setGridModalOpen}
                  gridModalOpen={gridModalOpen}
                />
              }
              {<SMSModal smsModal={smsModal} setSmsModal={setSmsModal} projectId={projectId} />}
              {isLoading && <LoaderModal />}
            </div>
          </div>
        </div>
      ) : (
        <LoadingAnimation imageStyling={''} styling={'h-screen '} />
      )}
    </>
  );
};

export default PermanentCampaigns;
